<script>
    import Panel from "./content-panel/Panel.svelte";
    import { Circle } from 'svelte-loading-spinners';
    import { onMount, onDestroy } from 'svelte';
    import { Constans } from '../lib/Constants';
    import { navigateTo } from 'svelte-router-spa';
    import {accountsByGroups} from "../lib/accounts";
    import SvelteTooltip from 'svelte-tooltip';
    import IosToggle from "./IosToggle.svelte";
    import AccountsList from "./AccountsList.svelte";
    import WhiteList from "./WhiteList.svelte";
    import { t, locale, locales } from "../../scripts/i18n";
    import NotificationBlock from "./NotificationBlock.svelte";

    export let params = {};

    let totalCounterCoef = 1;
    export let cleanFollowersBots = true;
    let cleanFollowersBotsProgress = 0;
    let cleanFollowersBotsTotalCounter = 492;
    let cleanFollowersBotsDone = false;
    export let cleanFollowersCommercials = true;
    let cleanFollowersCommercialsProgress = 0;
    let cleanFollowersCommercialsTotalCounter = 201;
    let cleanFollowersCommercialsDone = false;
    export let cleanFollowersInactive = true;
    let cleanFollowersInactiveProgress = 0;
    let cleanFollowersInactiveTotalCounter = 323;
    let cleanFollowersInactiveDone = false;
    export let cleanFollowersForeigners = true;
    let cleanFollowersForeignersProgress = 0;
    let cleanFollowersForeignersTotalCounter = 26;
    let cleanFollowersForeignersDone = false;
    export let cleanFollowersUnattainables = true;
    let cleanFollowersUnattainablesProgress = 0;
    let cleanFollowersUnattainablesTotalCounter = 327;
    let cleanFollowersUnattainablesDone = false;

    export let cleanFollowsBots = false;
    let cleanFollowsBotsProgress = 0;
    let cleanFollowsBotsTotalCounter = 6;
    let cleanFollowsBotsDone = false;
    export let cleanFollowsCommercials = false;
    let cleanFollowsCommercialsProgress = 0;
    let cleanFollowsCommercialsTotalCounter = 90;
    let cleanFollowsCommercialsDone = false;
    export let cleanFollowsInactive = false;
    let cleanFollowsInactiveProgress = 0;
    let cleanFollowsInactiveTotalCounter = 255;
    let cleanFollowsInactiveDone = false;
    export let cleanFollowsNonreciprocal = false;
    let cleanFollowsNonreciprocalProgress = 0;
    let cleanFollowsNonreciprocalTotalCounter = 278;
    let cleanFollowsNonreciprocalDone = false;
    export let cleanFollowsForeigners = false;
    let cleanFollowsForeignersProgress = 0;
    let cleanFollowsForeignersTotalCounter = 13;
    let cleanFollowsForeignersDone = false;

    let divHeight;

    let username = null;

    let isStarting = false;
    let isStopping = false;

    let scanProgress = 0;
    let followingsScanned = 0;
    let followersScanned = 0;
    let botsFound = 0;
    let commercialsFound = 0;
    let nonReciprocalFound = 0;
    let inactiveFound = 0;
    let foreignersFound = 0;
    let unattainableFound = 0;

    let selectedFollowersCategory = 'bots';
    let selectedFollowersCategoryList = [];
    $: selectedFollowersCategory && (selectedFollowersCategoryList = accountsByGroups.followers[selectedFollowersCategory]) && filterFollowers();

    let selectedFollowsCategory = 'bots';
    let selectedFollowsCategoryList = [];
    $: selectedFollowsCategory && (selectedFollowsCategoryList = accountsByGroups.follows[selectedFollowsCategory]);

    $: params && (username = params.stage ? params.stage.account.username : null);

    $: params && (!([Constans.ANALYZE_FINISHED, Constans.CLEANING_PAUSED, Constans.CLEANING_STARTED].includes(params.stage.status))) && navigateTo('/demo');

    const STATUSES = {
        SETUP: 'setup',
        PAUSE: 'pause',
        CLEANING: 'cleaning',
    };

    let currentStatus = STATUSES.SETUP;
    $: params && (params.stage.status === Constans.CLEANING_PAUSED) && (currentStatus = STATUSES.PAUSE);
    $: params && (params.stage.status === Constans.CLEANING_STARTED) && (currentStatus = STATUSES.CLEANING);

    let progressInterval;
    onMount(() => {
        window.scrollTo(0, 0);
        document.addEventListener('clean-pause', onCleanPause, {
            capture: true
        });
        document.addEventListener('clean-stop', onCleanStop, {
            capture: true
        });
        document.addEventListener('additional-settings-update', onAdditionalSettingsUpdate, {
            capture: true
        });
    });

    onDestroy(() => {
        document.removeEventListener('clean-pause', onCleanPause, {
            capture: true
        });
        document.removeEventListener('clean-stop', onCleanStop, {
            capture: true
        });
        document.removeEventListener('additional-settings-update', onAdditionalSettingsUpdate, {
            capture: true
        });
    });

    function onAdditionalSettingsUpdate(event) {
        if (event.detail.enableOverlappingAudience) {
            totalCounterCoef = 0.7;
        } else {
            totalCounterCoef = 1;
        }
    }

    function onCleanPause() {
        params.setStage({status: Constans.CLEANING_PAUSED});
        currentStatus = STATUSES.PAUSE;
    }

    function onCleanStop() {
        params.setStage({
            status: Constans.CLEANING_COMPLETE,
            cleanupStats: {
                finishedAt: (new Date()),
            }
        });
        document.dispatchEvent(new CustomEvent("cleanupFinished", {
            detail: { },
        }));
        navigateTo('/demo/clean-finished');
    }

    function stopCleanup() {
        params.setStage({
            status: Constans.CLEANING_COMPLETE,
            cleanupStats: {
                cleanProgress: 100,
                finishedAt: (new Date()),
            }
        });
        clearInterval(cleanupInterval);
        navigateTo('/demo/clean-finished');
        return;


        try {
            MicroModal.show('clean-stop');
        } catch (err) {
            console.error(err);
        }
    }
    function startCleanup() {
        isStarting = true;
        setTimeout(() => {
            isStarting = false;
            currentStatus = STATUSES.CLEANING;
            params.setStage({
                status: Constans.CLEANING_STARTED,
                cleanupStats: {
                    cleanProgress: 0,
                    threadsRemoved: 0,
                    followsBots: 0,
                    followsCommercial: 0,
                    followsNonreciprocal: 0,
                    followsInactive: 0,
                    followsForeigners: 0,
                    followsUnattainable: 0,
                    followersBots: 0,
                    followersCommercial: 0,
                    followersNonreciprocal: 0,
                    followersInactive: 0,
                    followersForeigners: 0,
                    followersUnattainable: 0,
                },
            });
            cleanupProgress();
        }, 1000);
    }

    let threadsRemoved = 0;
    let totalThreads = 0;
    let cleanupInterval = null;
    function cleanupProgress() {
        if (currentStatus !== STATUSES.CLEANING) return;

        let currentOptionProgress = 0;

        totalThreads = 0;
        if (cleanFollowersBots) {
            totalThreads += cleanFollowersBotsTotalCounter * totalCounterCoef;
        }
        if (cleanFollowersCommercials) {
            totalThreads += cleanFollowersCommercialsTotalCounter * totalCounterCoef;
        }
        if (cleanFollowersInactive) {
            totalThreads += cleanFollowersInactiveTotalCounter * totalCounterCoef;
        }
        if (cleanFollowersForeigners) {
            totalThreads += cleanFollowersForeignersTotalCounter * totalCounterCoef;
        }
        if (cleanFollowersUnattainables) {
            totalThreads += cleanFollowersUnattainablesTotalCounter * totalCounterCoef;
        }

        if (cleanFollowsBots) {
            totalThreads += cleanFollowsBotsTotalCounter * totalCounterCoef;
        }
        if (cleanFollowsCommercials) {
            totalThreads += cleanFollowsCommercialsTotalCounter * totalCounterCoef;
        }
        if (cleanFollowsInactive) {
            totalThreads += cleanFollowsInactiveTotalCounter * totalCounterCoef;
        }
        if (cleanFollowsNonreciprocal) {
            totalThreads += cleanFollowsNonreciprocalTotalCounter * totalCounterCoef;
        }
        if (cleanFollowsForeigners) {
            totalThreads += cleanFollowsForeignersTotalCounter * totalCounterCoef;
        }

        cleanupInterval = setInterval(() => {
            if (currentStatus === STATUSES.CLEANING && cleanFollowersBots) {
                    if (currentOptionProgress < 100) {
                        currentOptionProgress += 1;
                    } else {
                        cleanFollowersBots = false;
                        cleanFollowersBotsDone = true;
                        currentOptionProgress = 0;
                        threadsRemoved += cleanFollowersBotsTotalCounter * totalCounterCoef;

                        params.setStage({
                            cleanupStats: {
                                cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                                threadsRemoved: Math.round(threadsRemoved),
                                followersBots: Math.round(cleanFollowersBotsTotalCounter * totalCounterCoef),
                            }
                        });
                    }

                    cleanFollowersBotsProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowersCommercials) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowersCommercials = false;
                    cleanFollowersCommercialsDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowersCommercialsTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followersCommercial: Math.round(cleanFollowersCommercialsTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowersCommercialsProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowersInactive) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowersInactive = false;
                    cleanFollowersInactiveDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowersInactiveTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followersInactive: Math.round(cleanFollowersInactiveTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowersInactiveProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowersForeigners) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowersForeigners = false;
                    cleanFollowersForeignersDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowersForeignersTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followersForeigners: Math.round(cleanFollowersForeignersTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowersForeignersProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowersUnattainables) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowersUnattainables = false;
                    cleanFollowersUnattainablesDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowersUnattainablesTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followersUnattainable: Math.round(cleanFollowersUnattainablesTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowersUnattainablesProgress = currentOptionProgress;
                return;
            }

            if (currentStatus === STATUSES.CLEANING && cleanFollowsBots) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowsBots = false;
                    cleanFollowsBotsDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowsBotsTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followsBots: Math.round(cleanFollowsBotsTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowsBotsProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowsCommercials) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowsCommercials = false;
                    cleanFollowsCommercialsDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowsCommercialsTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followsCommercial: Math.round(cleanFollowsCommercialsTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowsCommercialsProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowsInactive) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowsInactive = false;
                    cleanFollowsInactiveDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowsInactiveTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followsInactive: Math.round(cleanFollowsInactiveTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowsInactiveProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowsNonreciprocal) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowsNonreciprocal = false;
                    cleanFollowsNonreciprocalDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowsNonreciprocalTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followsNonreciprocal: Math.round(cleanFollowsNonreciprocalTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowsNonreciprocalProgress = currentOptionProgress;
                return;
            }
            if (currentStatus === STATUSES.CLEANING && cleanFollowsForeigners) {
                if (currentOptionProgress < 100) {
                    currentOptionProgress += 1;
                } else {
                    cleanFollowsForeigners = false;
                    cleanFollowsForeignersDone = true;
                    currentOptionProgress = 0;
                    threadsRemoved += cleanFollowsForeignersTotalCounter * totalCounterCoef;

                    params.setStage({
                        cleanupStats: {
                            cleanProgress: Math.round(threadsRemoved / totalThreads * 100),
                            threadsRemoved: Math.round(threadsRemoved),
                            followsForeigners: Math.round(cleanFollowsForeignersTotalCounter * totalCounterCoef),
                        }
                    });
                }

                cleanFollowsForeignersProgress = currentOptionProgress;
                return;
            }

            if (currentStatus === STATUSES.CLEANING) {
                onCleanStop();
            }

            clearInterval(cleanupInterval);

        }, 10);
    }

    function shuffle(array) {
        let currentIndex = array.length,  randomIndex;

        while (currentIndex != 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }

    export let whitelist = [];
    $: params && params.stage && (whitelist = params.stage.whitelist);
    function addToWhitelist(account) {
        const foundItem = whitelist.find((item) => item.id == account.id);
        if (!foundItem) {
            whitelist.push(account);
        }

        whitelist = whitelist;
        selectedFollowersCategoryList = accountsByGroups.followers[selectedFollowersCategory];
        selectedFollowsCategoryList = accountsByGroups.follows[selectedFollowsCategory];
        params.setStage({
            whitelist
        });
    }

    function removeFromWhitelist(account) {
        const itemIndex = whitelist.findIndex((item) => item.id == account.id);
        if (itemIndex > -1) {
            whitelist.splice(itemIndex, 1);
        }

        whitelist = whitelist;
        selectedFollowersCategoryList = accountsByGroups.followers[selectedFollowersCategory];
        selectedFollowsCategoryList = accountsByGroups.follows[selectedFollowsCategory];
        params.setStage({
            whitelist
        });
    }

    function filterArray(arr, key) {
        if (!arr) return [];
        return arr.filter(item => item.username.includes(key));
    }

    let followersFilter = '';
    $: (followersFilter || !followersFilter) && filterFollowers();
    let followsFilter = '';
    $: (followsFilter || !followsFilter) && filterFollows();
    function filterFollowers() {
        selectedFollowersCategoryList = filterArray(accountsByGroups.followers[selectedFollowersCategory], followersFilter);
    }
    function filterFollows() {
        selectedFollowsCategoryList = filterArray(accountsByGroups.follows[selectedFollowsCategory], followsFilter);
    }

    function showCustomSettingsModal() {
        if (currentStatus === STATUSES.CLEANING) return;

        try {
            if (window.language === 'ru-RU') {
                MicroModal.show('clean-settings-ru');
            } else {
                MicroModal.show('clean-settings-en');
            }

        } catch (err) {
            console.error(err);
        }
    }


    function backToDashboard() {
        params.setStage({
            status: Constans.CLEANING_COMPLETE,
            cleanupStats: {
                cleanProgress: 100,
                finishedAt: (new Date()),
            }
        });

        clearInterval(cleanupInterval);
        navigateTo('/demo');
    }
</script>

<div class="analyze-in-progress-wrap position-relative" style={`min-height: ${divHeight}px;`}>
    <div class="banner-top">

    </div>

    <div class="inner-content-wrap position-absolute top-0 w-100pc" bind:clientHeight={divHeight}>
        <Panel>
            <span slot="title">{$t('Scan and cleaning')}</span>
            <span slot="back-btn">
                {#if currentStatus === STATUSES.SETUP}
                    <a href="/demo">
                        <img src="/static/media/back.9eb4f248.svg" width="30" alt="/">
                    </a>
                {:else}
                    <a href="#" on:click={backToDashboard}>
                        <img src="/static/media/back.9eb4f248.svg" width="30" alt="/">
                    </a>
                {/if}
            </span>
            <div slot="content">
                <div class="status-panel mb-45px">
                    <ul class="list-inline">
                        <li class="list-inline-none">{$t('Step 1: Scan')}</li>
                        <li class="active">{$t('Step 2: Settings and cleaning')}</li>
                        <li class="list-inline-none">{$t('Step 3: Result')}</li>
                    </ul>
                </div>

                <div>
                    <NotificationBlock />
                </div>

                <div class="cleaning-controls-wrap">
                    <div class="start-btn-wrap mb-20px">
                        {#if params.stage.status === Constans.CLEANING_STARTED}
                            <a href="#" on:click={stopCleanup} class="purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Stop clean')}
                                {#if isStopping}
                                    <span class="ml-10px">
                                        <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                    </span>
                                {/if}
                            </a>
                        {:else if params.stage.status === Constans.CLEANING_PAUSED}
                            <a href="#" on:click={startCleanup} class=" purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Continue cleaning')}
                                {#if isStarting}
                                    <span class="ml-10px">
                                        <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                    </span>
                                {/if}
                            </a>
                        {:else }
                            <a href="#" on:click={startCleanup} class="pulse-button purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Start cleaning')}
                                {#if isStarting}
                                    <span class="ml-10px">
                                        <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                    </span>
                                {/if}
                            </a>
                        {/if}
                        <div class="description-wrap">
                            {$t('Start improving your account')}
                        </div>
                    </div>
                    <div class="add-settings-wrap mb-20px">
                        <a href="#" class={`white-btn white-btn_hover w-210px h-45px ${currentStatus === STATUSES.CLEANING ? 'disabled' : ''}`} on:click={showCustomSettingsModal}>
                            {$t('Add settings')}
                        </a>
                        <div class="description-wrap">
                            {$t('Additional cleaning settings')}
                        </div>
                    </div>
                </div>

                <div class="followers-wrap setup-panel-wrap">
                    <div class="panel-columns-wrap mb-20px">
                        <div class="categories-wrap">
                            <div class="header-wrap mb-20px">
                                <div class="title-wrap mb-10px">{$t('Followers')}</div>
                                <div class="description-wrap">{$t('To change the followers list, click on any category')}</div>
                            </div>
                            <div class="categories-list">
                                <a class={`category-wrap ${selectedFollowersCategory === 'bots' ? 'active' : ''}`} on:click={() => {selectedFollowersCategory = 'bots'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip right >
                                            <span slot="custom-tip" class="custom-tip">
                                                <div>
                                                {$t('Bots accounts were automatically created or left by their owners')}
                                                </div>
                                            </span>
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Bots')}
                                    </div>
                                    {#if currentStatus === STATUSES.CLEANING}
                                        {#if !cleanFollowersBots}
                                            <div class="option-status-wrap progress-off">
                                                {#if cleanFollowersBotsDone}
                                                    {$t('Done!')}
                                                {:else}
                                                    {$t('Switched off')}
                                                {/if}
                                            </div>
                                        {:else}
                                            <div class="progress-wrap">
                                                <div class="progress-graph" style={`width: ${cleanFollowersBotsProgress}%;`}></div>
                                                <div class="progress-value">{cleanFollowersBotsProgress}%</div>
                                            </div>
                                        {/if}
                                    {:else}
                                        <div class="counter-wrap">
                                            {Math.round(cleanFollowersBotsTotalCounter * totalCounterCoef)}
                                        </div>
                                        <div class="toggler-wrap">
                                            <IosToggle
                                                    label=""
                                                    bind:checked={cleanFollowersBots}
                                                    disabled={false}
                                                    showTooltip={false}
                                                    tooltipTitle={null}
                                                    tooltipContent=""
                                                    backgroundColor="#8001BD"
                                                    widgetClass="w-100pc"
                                            />
                                        </div>
                                    {/if}
                                </a>
                                <a class={`category-wrap ${selectedFollowersCategory === 'commercial' ? 'active' : ''}`} on:click={() => {selectedFollowersCategory = 'commercial'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip right >
                                            <span slot="custom-tip" class="custom-tip">
                                                <div>
                                                    {$t('Commercials include business-profiles and other accounts created for selling goods and services.')}
                                                </div>
                                            </span>
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Commercial')}
                                    </div>
                                    {#if currentStatus === STATUSES.CLEANING}
                                        {#if !cleanFollowersCommercials}
                                            <div class="option-status-wrap progress-off">
                                                {#if cleanFollowersCommercialsDone}
                                                    {$t('Done!')}
                                                {:else}
                                                    {$t('Switched off')}
                                                {/if}
                                            </div>
                                        {:else}
                                            <div class="progress-wrap">
                                                <div class="progress-graph" style={`width: ${cleanFollowersCommercialsProgress}%;`}></div>
                                                <div class="progress-value">{cleanFollowersCommercialsProgress}%</div>
                                            </div>
                                        {/if}
                                    {:else}
                                        <div class="counter-wrap">
                                            {Math.round(cleanFollowersCommercialsTotalCounter * totalCounterCoef)}
                                        </div>
                                        <div class="toggler-wrap">
                                            <IosToggle
                                                    label=""
                                                    bind:checked={cleanFollowersCommercials}
                                                    disabled={false}
                                                    showTooltip={false}
                                                    tooltipTitle={null}
                                                    tooltipContent=""
                                                    backgroundColor="#8001BD"
                                                    widgetClass="w-100pc"
                                            />
                                        </div>
                                    {/if}
                                </a>
                                <a class={`category-wrap ${selectedFollowersCategory === 'inactive' ? 'active' : ''}`} on:click={() => {selectedFollowersCategory = 'inactive'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip right >
                                            <span slot="custom-tip" class="custom-tip">
                                                <div>
                                                    {$t("Inactive users haven’t liked and commented photos you posted for more than a month, and also haven’t published any photos by themselves during that period")}
                                                </div>
                                            </span>
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Inactive')}
                                    </div>
                                    {#if currentStatus === STATUSES.CLEANING}
                                        {#if !cleanFollowersInactive}
                                            <div class="option-status-wrap progress-off">
                                                {#if cleanFollowersInactiveDone}
                                                    {$t('Done!')}
                                                {:else}
                                                    {$t('Switched off')}
                                                {/if}
                                            </div>
                                        {:else}
                                            <div class="progress-wrap">
                                                <div class="progress-graph" style={`width: ${cleanFollowersInactiveProgress}%;`}></div>
                                                <div class="progress-value">{cleanFollowersInactiveProgress}%</div>
                                            </div>
                                        {/if}
                                    {:else}
                                        <div class="counter-wrap">
                                            {Math.round(cleanFollowersInactiveTotalCounter * totalCounterCoef)}
                                        </div>
                                        <div class="toggler-wrap">
                                            <IosToggle
                                                    label=""
                                                    bind:checked={cleanFollowersInactive}
                                                    disabled={false}
                                                    showTooltip={false}
                                                    tooltipTitle={null}
                                                    tooltipContent=""
                                                    backgroundColor="#8001BD"
                                                    widgetClass="w-100pc"
                                            />
                                        </div>
                                    {/if}
                                </a>
                                <a class={`category-wrap ${selectedFollowersCategory === 'foreigners' ? 'active' : ''}`} on:click={() => {selectedFollowersCategory = 'foreigners'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip right >
                                            <span slot="custom-tip" class="custom-tip">
                                                <div>
                                                    {$t('The users that speak different languages')}
                                                </div>
                                            </span>
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Foreigners')}
                                    </div>
                                    {#if currentStatus === STATUSES.CLEANING}
                                        {#if !cleanFollowersForeigners}
                                            <div class="option-status-wrap progress-off">
                                                {#if cleanFollowersForeignersDone}
                                                    {$t('Done!')}
                                                {:else}
                                                    {$t('Switched off')}
                                                {/if}
                                            </div>
                                        {:else}
                                            <div class="progress-wrap">
                                                <div class="progress-graph" style={`width: ${cleanFollowersForeignersProgress}%;`}></div>
                                                <div class="progress-value">{cleanFollowersForeignersProgress}%</div>
                                            </div>
                                        {/if}
                                    {:else}
                                        <div class="counter-wrap">
                                            {Math.round(cleanFollowersForeignersTotalCounter * totalCounterCoef)}
                                        </div>
                                        <div class="toggler-wrap">
                                            <IosToggle
                                                    label=""
                                                    bind:checked={cleanFollowersForeigners}
                                                    disabled={false}
                                                    showTooltip={false}
                                                    tooltipTitle={null}
                                                    tooltipContent=""
                                                    backgroundColor="#8001BD"
                                                    widgetClass="w-100pc"
                                            />
                                        </div>
                                    {/if}
                                </a>
                                <a class={`category-wrap ${selectedFollowersCategory === 'unattainable' ? 'active' : ''}`} on:click={() => {selectedFollowersCategory = 'unattainable'}}>
                                    <div class="tooltip-wrap">
                                        <SvelteTooltip right >
                                            <span slot="custom-tip" class="custom-tip">
                                                <div>
                                                    {$t('Users who are most likely not to see your posts at all')}
                                                </div>
                                            </span>
                                            <img src="/static/media/ant-design_question-circle-filled.e4dc2b6a.svg" class="tooltip-img" />
                                        </SvelteTooltip>
                                    </div>
                                    <div class="title-wrap">
                                        {$t('Unattainable')}
                                    </div>
                                    {#if currentStatus === STATUSES.CLEANING}
                                        {#if !cleanFollowersUnattainables}
                                            <div class="option-status-wrap progress-off">
                                                {#if cleanFollowersUnattainablesDone}
                                                    {$t('Done!')}
                                                {:else}
                                                    {$t('Switched off')}
                                                {/if}
                                            </div>
                                        {:else}
                                            <div class="progress-wrap">
                                                <div class="progress-graph" style={`width: ${cleanFollowersUnattainablesProgress}%;`}></div>
                                                <div class="progress-value">{cleanFollowersUnattainablesProgress}%</div>
                                            </div>
                                        {/if}
                                    {:else}
                                        <div class="counter-wrap">
                                            {Math.round(cleanFollowersUnattainablesTotalCounter * totalCounterCoef)}
                                        </div>
                                        <div class="toggler-wrap">
                                            <IosToggle
                                                    label=""
                                                    bind:checked={cleanFollowersUnattainables}
                                                    disabled={false}
                                                    showTooltip={false}
                                                    tooltipTitle={null}
                                                    tooltipContent=""
                                                    backgroundColor="#8001BD"
                                                    widgetClass="w-100pc"
                                            />
                                        </div>
                                    {/if}
                                </a>
                            </div>
                        </div>
                        <div class="accounts-wrap">
                            <div class="header-wrap">
                                <div class="description-wrap">
                                    {$t('We will remove these accounts. Please click on the')}
                                    <img src="/static/media/flat-color-icons_ok.ec482660.svg" class="" width="20" /> {$t('to add the account to the exclusion list if it got here by mistake')}
                                </div>
                            </div>
                            <div class="accounts-list-wrap ml-10px mr-10px">
                                <div class="accounts-list">
                                    <div class="accounts-search-wrap">
                                        <div class="styled-input-wrap mx-auto bg-white color-black">
                                            <div class="input-wrap pl-10px text-left">
                                                <input type="text" class="h-27px bg-grey " bind:value={followersFilter} placeholder="{$t('User search')}"/>
                                            </div>
                                            <div class="input-post-wrap">
                                                <img src="/static/media/bx_bx-search.c653d834.svg" class="mr-10px" alt="/">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accounts-list-wiget-wrap style-2">
                                        <AccountsList
                                                whitelist={whitelist}
                                                list={selectedFollowersCategoryList}
                                                addToWhitelist={addToWhitelist}
                                                removeFromWhitelist={removeFromWhitelist}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-break" />
                        <div class="whitelist-wrap">
                            <div class="header-wrap">
                                <div class="intro-title text-align-left pl-10px">{$t('Whitelist header text')}</div>
                                <div class="intro-description description-wrap text-align-left">
                                    {$t('Whitelist header description')}
                                </div>
                            </div>
                            <div class="whitelist-accounts-wrap">
                                <div class="header">
                                    {whitelist.length} {whitelist.length === 1 ? $t('exception') : $t('exceptions')}
                                </div>
                                <div class="whitelist-wiget-wrap style-2">
                                    <WhiteList list={whitelist} removeFromWhitelist={removeFromWhitelist} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-footer-wrap">
                        <a href="#" class="">{$t('Open account list to remove manually')}
                            <span class="tooltip-wrap">
                                <SvelteTooltip top >
                                    <span slot="custom-tip" class="custom-tip">
                                        <div>
                                        {$t('If Instagram has temporarily blocked your automatic cleaning with Bot-Removal for some reason, you can delete unwanted accounts manually.')}
                                        </div>
                                    </span>
                                    <img src="/static/media/ant-design_question-circle-outlined.0717a98b.svg" alt="/">
                                </SvelteTooltip>
                            </span>
                        </a>
                    </div>
                </div>


                <div class="cleaning-controls-wrap">
                    <div class="start-btn-wrap mb-20px">
                        {#if params.stage.status === Constans.CLEANING_STARTED}
                            <a href="#" on:click={stopCleanup} class="purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Stop clean')}
                                {#if isStopping}
                                    <span class="ml-10px">
                                        <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                    </span>
                                {/if}
                            </a>
                        {:else if params.stage.status === Constans.CLEANING_PAUSED}
                            <a href="#" on:click={startCleanup} class=" purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Continue cleaning')}
                                {#if isStarting}
                                    <span class="ml-10px">
                                        <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                    </span>
                                {/if}
                            </a>
                        {:else }
                            <a href="#" on:click={startCleanup} class="pulse-button purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Start cleaning')}
                                {#if isStarting}
                                    <span class="ml-10px">
                                        <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                    </span>
                                {/if}
                            </a>
                        {/if}
                        <div class="description-wrap">
                            {$t('Start improving your account')}
                        </div>
                    </div>
                    <div class="add-settings-wrap mb-20px">
                        <a href="#" class={`white-btn white-btn_hover w-210px h-45px ${currentStatus === STATUSES.CLEANING ? 'disabled' : ''}`} on:click={showCustomSettingsModal}>{$t('Add settings')}</a>
                        <div class="description-wrap">
                            {$t('Additional cleaning settings')}
                        </div>
                    </div>
                </div>

            </div>
        </Panel>
    </div>

</div>

<style>
    @media (max-device-width: 480px) {
        .cleaning-controls-wrap {
            flex-direction: column;
        }
    }
    @media (max-device-width: 800px) {
        .panel-columns-wrap {
            flex-direction: column;
        }
        .categories-wrap, .accounts-wrap, .whitelist-wrap {
            width: 100% !important;
        }
    }
    .pulse-button.purple-btn {
        margin: auto;
    }
    .white-btn.white-btn_hover {
        margin: auto;
    }
    .progress-wrap {
        width: 100px;
        border-radius: 10px;
        border: 1px solid #999;
        overflow: hidden;
        position: relative;
        background-color: #ddd;
    }
    .progress-graph {
        height: 22px;
        background-color: #8001BD;
        display: block;
    }
    .progress-value {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
    }

    .progress-off {
        font-family: Roboto;
        font-style: normal;
        text-align: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 33px;
        color: #9400d3;
        padding-left: 21px;
    }

    .whitelist-accounts-wrap {
        border: 1px solid #8001bd;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .whitelist-accounts-wrap .header {
        background-color: #f2dede;
        border-color: #ebccd1;
        border-radius: 8px 8px 0 0;
        background: linear-gradient(90deg,#9400d3,indigo);
        padding: 10px 15px;
        border-bottom: 1px solid transparent;

        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #fff;
    }

    .whitelist-wiget-wrap {
        overflow-y: scroll;
        overflow-x: hidden;
        height: 197px;
        padding: 8px;
    }
    .accounts-search-wrap {
        border-radius: 10px 10px 0 0;
        background: #ddd;
        border-bottom: 1px solid #8001bd;
        box-sizing: border-box;
        color: #fff;
        padding: 10px 15px;
    }
    .panel-columns-wrap {
        display: flex;
        justify-content: left;
        align-items: center;
        flex-wrap: wrap;
    }
    .flex-break {
        flex-grow: 1;
    }
    .panel-footer-wrap a, .panel-footer-wrap a:hover {
        color: indigo;
        text-decoration: none;
    }
    .panel-footer-wrap {
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        -webkit-text-decoration-line: underline;
        text-decoration-line: underline;
        text-decoration: none;
        border-top: 0.3px solid #8a8585;
        padding: 19px 0 0;
    }

    .setup-panel-wrap {
        background: #fff;
        border: 0.5px solid #8a8585;
        box-sizing: border-box;
        box-shadow: 0 4px 10px rgba(0,0,0,.25);
        border-radius: 21px;
        padding: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        text-align: center;
        min-height: 388px;
    }
    .setup-panel-wrap .header-wrap {
        height: 75px;
    }
    .setup-panel-wrap .header-wrap .title-wrap {
        font-family: Roboto;
        font-style: normal;
        text-align: center;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
    }
    .setup-panel-wrap .header-wrap .description-wrap {
        min-height: 75px;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        padding: 0 10px;
    }

    .accounts-list-wrap {
        border: 1px solid #8001bd;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .accounts-list-wrap .accounts-list-wiget-wrap {
        padding: 5px;
        overflow-y: scroll;
        overflow-x: hidden;
        height: 185px;
    }

    .categories-list {
        height: 245px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }
    .categories-wrap {
        width: 42%;
    }
    .accounts-wrap {
        width: 58%;
    }
    .category-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        text-decoration: none;
        padding: 5px;
    }
    .category-wrap:hover {
        color: #000;
        text-decoration: none;
        background-color: rgba(148,0,211,.15);
    }
    .category-wrap.active {
        background-color: rgba(148,0,211,.15);
    }
    .category-wrap .title-wrap {
        flex-grow: 1;
    }
    .category-wrap .toggler-wrap {
        width: 50px;
    }
    .category-wrap .counter-wrap {
        width: 50px;
        text-align: right;
        font-weight: 700;
        font-size: 16px;
        margin-right: 10px;
    }
    .category-wrap .tooltip-wrap {
        width: 50px;
    }
    .category-wrap .title-wrap {
        text-align: left;
        font-family: Roboto;
        font-style: normal;
        color: #000;
        font-weight: 300;
        font-size: 14px;
    }
    .whitelist-wrap {
        width: 42%;
    }
    .whitelist-wrap .header-wrap {
        height: 90px;
    }

    .cleaning-controls-wrap {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    .cleaning-controls-wrap .description-wrap {
        margin-top: 6px;
        font-family: Roboto,sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #8001bd;
    }
    .scan-block_content-step1-h {
        display: flex;
        justify-content: left;
        align-items: center;
    }
    .scan-block_content-step1-h > span {
        flex-grow: 1;
    }
    .controls-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .list-inline {
        margin: 0;
        border-bottom: 0.3px solid #8a8585;
        padding-left: 0;
        list-style: none;
    }

    .list-inline .active {
        font-weight: 600;
        border-bottom: 5px solid indigo;
    }
    .list-inline li {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        color: #909090;
        padding: 15px 25px;
    }
    .list-inline>li {
        display: inline-block;
    }

    .header-wrap .intro-title {
        margin-bottom: 10px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        line-height: 23px;
    }
    .header-wrap .intro-description {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 15px;
        padding: 0 10px;
        padding-top: 11px;
        min-height: 75px;
    }

</style>